@layer module {
.surface {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
    }

.amount {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            width: 100%;
    }

.info {
            width: 100%;
    }

.preview {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
            width: 100%;
    }
} // layer module










@layer app {
.surface {
            max-width: $size-500;
            padding: $size-24 $size-20;
            gap: $size-30;
    }

.surface h3 {
            margin: 0;
            padding-right: $size-40;
    }

.surface-compact {
            max-width: $size-450;
            gap: 0;
    }

.amount {
            gap: $size-10;
    }

.preview {
            margin-top: $size-20;
    }

      @media (min-width: 480px) {
                .surface {
                        padding: $size-40 $size-50;
                    }
          }

.surface {
            width: var(--modal-fill-inline-size);
    }

.surface h3 {
            font-size: var(--font-size-xl);
            line-height: $size-28;
            font-weight: 400;
    }

.amount {
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-29;
    }

.preview {
            font-size: var(--font-size-base);
    }

.preview :global(.amount) {
            color: var(--banky-black);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 600;
            line-height: $size-29;
    }
} // layer app
